<template>
  <div class="healing-modal-container" v-if="isShowModal">
    <!-- 遮罩层 -->
    <div class="modal-mask" @click="closeModal"></div>
    <!-- 弹窗主体 -->
    <div class="modal-content">
      <!-- 标题与关闭按钮 -->
      <div class="modal-header">
        <h3 class="modal-title">请选择你所使用的疗愈模式</h3>
        <img
          @click="closeModal"
          class="close-btn"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde2.png"
          alt=""
        />
      </div>
      <!-- 模式选择项 -->
      <div class="modal-body">
        <div
          class="mode-item"
          v-for="(item, index) in modeList"
          :key="index"
          :class="{ active: selected === item.type }"
          @click="selectMode(item.type, index)"
        >
          <img
            v-if="item.type == selected"
            class="mode-icon"
            :src="item.noImg"
            alt=""
          />
          <img v-else class="mode-icon" :src="item.img" alt="" />
          <p class="mode-name">{{ item.name }}</p>
        </div>
      </div>
      <!-- 确定按钮 -->
      <div class="modal-footer">
        <button
          class="confirm-btn"
          :disabled="!selected"
          :class="{ 'active-but': selected }"
          @click="confirmMode"
        >
          确定
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HealingModal",
  data() {
    return {
      // 弹窗显示状态
      isShowModal: false,
      selected: 0,
      // 疗愈模式列表
      modeList: [
        {
          name: "睡眠模式",
          type: "sleep",
          img: "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10selectModelicon1.png",
          noImg:
            "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10selectModelicon5.png",
        },
        {
          name: "活力模式",
          type: "energize",
          img: "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10selectModelicon2.png",
          noImg:
            "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10selectModelicon6.png",
        },
        {
          name: "解压模式",
          type: "relax",
          img: "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10selectModelicon3.png",
          noImg:
            "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10selectModelicon7.png",
        },
        {
          name: "舒缓模式",
          type: "soothe",
          img: "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10selectModelicon4.png",
          noImg:
            "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10selectModelicon8.png",
        },
      ],
    };
  },
  watch: {
    // 监听弹窗显示状态，控制页面滚动
    isShowModal(newVal) {
      if (newVal) {
        // 弹窗显示：禁止页面滚动
        document.body.style.overflow = "hidden";
      } else {
        // 弹窗关闭：恢复页面滚动
        document.body.style.overflow = "auto";
        document.body.style.paddingRight = "0";
      }
    },
  },
  mounted() {
    // 初始显示弹窗时，执行滚动控制
    if (this.isShowModal) {
      document.body.style.overflow = "hidden";
    }
  },
  beforeDestroy() {
    // 组件销毁前，恢复页面滚动状态
    document.body.style.overflow = "auto";
    document.body.style.paddingRight = "0";
  },
  methods: {
    // 选择模式
    selectMode(type, index) {
      this.selectedIndex = index
      this.selected = type;
    },
    open() {
      this.selected = 0
      this.isShowModal = true;
    },
    // 确定选择
    confirmMode() {
      if (this.selectedIndex !== -1) {
        const selectedMode = this.modeList[this.selectedIndex].type;
        this.isShowModal = false;
        console.log("选中的疗愈模式：", selectedMode);
        localStorage.setItem('mode', selectedMode)
        this.$router.replace("/IntendCollect");
      }
    },
    // 关闭弹窗
    closeModal() {
      this.isShowModal = false;
      this.selectedIndex = -1; // 重置选中状态
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .healing-modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;

    .modal-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }

    .modal-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 68.75rem;
      height: 33.5rem;
      background: #fff;
      border-radius: 2rem;
      box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);
      box-sizing: border-box;
      padding-top: 3.25rem;

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: auto;
        margin-bottom: 3.25rem;
        width: 53.625rem;

        .modal-title {
          font-weight: 800;
          font-size: 1.875rem;
          color: #101424;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .close-btn {
          width: 1.875rem;
          height: 1.875rem;
          color: #000;
          cursor: pointer;
          line-height: 1;

          &:hover {
            color: #999;
          }
        }
      }

      .modal-body {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: auto;
        margin-bottom: 3.25rem;
        width: 53.625rem;

        .mode-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 12.5rem;
          height: 12.5rem;
          background: #f5f6fe;
          border-radius: 1.25rem;
          box-sizing: border-box;
          cursor: pointer;
          transition: all 0.2s ease;
          color: #bfc3cf;

          .mode-icon {
            width: 3.5rem;
            height: 3.5rem;
            margin-bottom: 1.3rem;
          }

          .mode-name {
            font-weight: 500;
            font-size: 1.25rem;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          &.active {
            background: #0074fc;
            color: #fff;
          }
        }
      }

      .modal-footer {
        display: flex;
        justify-content: center;

        .confirm-btn {
          width: 12.5rem;
          height: 5rem;
          background: #f5f6fe;
          border-radius: 1.25rem;
          border: none;
          font-size: 0.875rem; // 14px / 16
          cursor: pointer;
          transition: background 0.2s ease;

          font-weight: 500;
          font-size: 1.5rem;
          color: #bfc3cf;
          text-align: center;
          font-style: normal;
          text-transform: none;

          &:disabled {
            background: #f5f6fe;
            color: #ccc;
            cursor: not-allowed;
          }
        }
        .active-but {
          background: #0074fc;
          color: #fff;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .healing-modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;

    .modal-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }

    .modal-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 37.5rem;
      height: auto;
      background: #fff;
      border-radius: 2rem;
      box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);
      box-sizing: border-box;
      padding-top: 2rem;
      padding-bottom: 3rem;

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: auto;
        margin-bottom: 3.25rem;
        width: 33rem;

        .modal-title {
          font-weight: bold;
          font-size: 2rem;
          color: #101424;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .close-btn {
          width: 2.5rem;
          height: 2.5rem;
          color: #000;
          // cursor: pointer;
          line-height: 1;

          &:hover {
            color: #999;
          }
        }
      }

      .modal-body {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: auto;
        margin-bottom: 0.75rem;
        width: 33rem;

        .mode-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 15.75rem;
          height: 15.75rem;
          margin-bottom: 1.5rem;
          background: #f5f6fe;
          border-radius: 1.5rem;
          box-sizing: border-box;
          // cursor: pointer;
          // transition: all 0.2s ease;
          color: #bfc3cf;

          .mode-icon {
            width: 4rem;
            height: 4rem;
            margin-bottom: 1.8rem;
          }

          .mode-name {
            font-weight: 500;
            font-size: 2rem;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
          &.active {
            background: #0074fc;
            color: #fff;
          }
        }
      }

      .modal-footer {
        margin: auto;
        display: flex;
        justify-content: center;

        .confirm-btn {
          width: 33rem;
          height: 6.5rem;
          background: #f5f6fe;
          border-radius: 1.5rem;
          border: none;
          font-size: 2rem;
          // cursor: pointer;
          transition: background 0.2s ease;

          font-weight: 500;
          color: #bfc3cf;
          text-align: center;
          font-style: normal;
          text-transform: none;

          &:disabled {
            background: #f5f6fe;
            color: #ccc;
            cursor: not-allowed;
          }
        }
        .active-but {
          background: #0074fc;
          color: #fff;
        }
      }
    }
  }
}
</style>